import { Component, DestroyRef, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ACTION_ID } from 'src/app/common/constants';
import { Services } from 'src/app/services/api.service';
import { OrderService } from 'src/app/services/getOrder.service';
import { environment } from 'src/environments/environment';
import { NavigationCartService } from './navigation.cart.service';
import { HelperFunctionsService } from 'src/app/services/helper-functions.service';
import { GlobalConstants } from 'src/app/common/global';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CartInfoBoxComponent } from '../cart-info-box/cart-info-box.component';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Order } from 'src/app/common/event.model';
import { ModalNames } from 'src/app/common/modal.config';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-navigation-cart',
  templateUrl: `./${environment.pageFolder}/navigation-cart.${environment.pageFolder}.component.html`,
  styleUrls: [`./${environment.pageFolder}/navigation-cart.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, TranslateModule, CartInfoBoxComponent, RouterModule]
})

export class NavigationCartComponent implements OnInit {
  cart: any = {};
  cartItemsFormatted: Array<any> = [];
  cartIsOpen = false;
  orderId: any;
  countdownTimer: any;
  remainingTime: string = ""; 
  cartLink: string = "";
  cartItemsLength: number = 0;

  constructor(
    private Services: Services,
    private Router: Router,
    private readonly orderService: OrderService,
    private navigationCartService: NavigationCartService,
    private helperFunctionsService: HelperFunctionsService,
    private readonly destroyRef: DestroyRef,
    private modalService: ModalService
  ) {}

  ngOnInit(): void {
    GlobalConstants.isAuth && this.navigationCartService.getLastOrder().subscribe((data) => {
      this.orderId = data.data;
      this.orderId && this.getCartItems();
    });
    
    this.subscribeToOrderUpdates();    
  }
  
  getCartItems() {
    setTimeout(() => {
      this.orderService.getOrder(this.orderId, false).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (order) => {
          this.addToCartItemsFormatted(order);
        },
        error: (error) => {
          if (error.status === 401) {
            this.Services.logout();
          }
        }
      });
    }, 500);
  }

  subscribeToOrderUpdates() {
    this.orderService.order$
      .pipe(
        filter(order => order !== null),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(order => {
        this.addToCartItemsFormatted(order);
      });
  }

  addToCartItemsFormatted(response: Order) {
    let cartItem = response;
    if(cartItem.items.length === 0) {
      this.cart = null;
      this.cartIsOpen = false;
      return;
    }

    this.cart = cartItem;
    this.cartItemsLength = cartItem.items.length;

    if(cartItem.transactionInfo.ticketDelagation) {
      this.cartLink = 'transfer-tickets';
    } else {
      this.cartLink = `event/${environment.connId}/${this.cart.items[0].eventId}/${this.cart.transactionInfo.actionId}/${this.cart.items[0].hashedId}`;
    }

    if(cartItem.transactionInfo) {
      this.helperFunctionsService.startCountdown();

      this.helperFunctionsService.remainingTime$.subscribe(time => {
        this.remainingTime = time;
      });
    }
  }

  toggleCart() {
    this.cartIsOpen = !this.cartIsOpen;
  }

  cancelOrder() {
    const newUrl = {
      changeUrl: false,
      url: ""
    }

    this.Services.cancelOrder(this.cart.id, false, newUrl);
  }

  toOrder() {
    //let actionId = this.hasPayment ? ACTION_ID.NORMAL : ACTION_ID.FREE_TICKET;
    let actionId = ACTION_ID.NORMAL;
    const eventId = this.cart.items[0].eventId;
    const orderId = this.cart.id;
    this.toggleCart();
    this.Router.navigate([`order/${environment.connId}/${eventId}/${orderId}/${actionId}`]);
  }

  goToCart() {
    sessionStorage.setItem("scrollToCart", "true");
    if(this.cart?.transactionInfo?.actionId === "114" || Number(this.cart?.transactionInfo?.actionId) === ACTION_ID.EXCLUSIVE_SUBSCRIBER_TICKET || Number(this.cart?.transactionInfo?.actionId) === ACTION_ID.SUBSCRIBER_TICKET_OS) {
      this.Router.navigate([`/`]);
      this.modalService.openModal(ModalNames.HomepageModal);
    } else if(this.cartLink) {
      this.Router.navigate([this.cartLink]);
    } else {
      this.Router.navigate(['/user-profile']);
    }
  }
}
